import styled from '@emotion/styled';
import { sunriseSemanticTokens as theme, media } from '@vfit/shared/themes';
import { IStyledProps } from './alert.models';

export const StyledAlert = styled.div<IStyledProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 0 2px 0 0;
  border-radius: ${theme.radius.sm};
  border-color: ${(props) => {
    let color;
    switch (props.type) {
      case 'success':
        color = theme.colors.text.success;
        break;
      case 'error':
        color = theme.colors.brand.primaryHover;
        break;
      case 'warning':
        color = '#eb9700';
        break;
      default:
        color = '#005ea5';
        break;
    }
    return color;
  }};
  background: ${(props) => {
    let color;
    switch (props.type) {
      case 'success':
        color = theme.colors.text.success;
        break;
      case 'error':
        color = theme.colors.brand.primaryHover;
        break;
      case 'warning':
        color = '#eb9700';
        break;
      default:
        color = '#005ea5';
        break;
    }
    return color;
  }};
`;

export const StyledIconContainer = styled.div`
  padding: ${theme.spacing.md};
  border: none;

  & svg {
    vertical-align: middle;
  }
`;

export const StyledText = styled.div`
  margin: 0;
  text-align: start;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.body2};
  line-height: ${theme.typography.lineHeight.body2};
  padding: ${theme.spacing.md};
  background: ${theme.colors.bg.primary};
  width: 100%;
  border-top: ${theme.borderWidth.default} solid;
  border-bottom: ${theme.borderWidth.default} solid;
  border-color: inherit;
  border-radius: 0 ${theme.radius.sm} ${theme.radius.sm} 0;

  p {
    margin: 0;
  }

  ${media.tablet`
    font-size: ${theme.typography.fontSize.body1};
    line-height: ${theme.typography.lineHeight.body1};
  `}
`;
